import { Link as RouterLink } from "react-router-dom";
import { ProductPricebookItem } from "../../../types/product.type";
import { SectionTitle } from "../shared/FormField";
import { priceBookDetailsPath } from "../shared/constants";
import PricebookItemPrice from "./PricebookItemPrice";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

interface ProductPriceBookListProps {
  items: ProductPricebookItem[];
}

/**
 * The pricebooks this product is priced in. Read-only by design: a product joins
 * a pricebook from the pricebook screen, never from the product form.
 */
export default function ProductPriceBookList({
  items,
}: ProductPriceBookListProps) {
  return (
    <>
      <SectionTitle>สมุดราคา</SectionTitle>
      {items.length === 0 ? (
        <Typography variant="caption" color="text.secondary">
          ยังไม่ได้อยู่ในสมุดราคาใด เพิ่มสินค้าเข้าสมุดราคาได้จากหน้าสมุดราคา
        </Typography>
      ) : (
        <>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mb: 1 }}
          >
            ใช้งาน {items.length} สมุด · แก้ไขราคาได้จากหน้าสมุดราคา
          </Typography>
          <Stack gap={0.5} sx={{ mb: 2, [compact]: { mb: 1.25 } }}>
            {items.map((item) => (
              <Stack
                key={item.pricebook_code}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                gap={2}
                sx={{
                  px: 1.5,
                  py: 1,
                  borderRadius: 1,
                  bgcolor: (theme) => theme.palette.background.default,
                }}
              >
                {/* A price row can outlive its pricebook master row: it keeps the
                    code but has no page to link to. */}
                {item.pricebook_uuid ? (
                  <Link
                    component={RouterLink}
                    to={priceBookDetailsPath(item.pricebook_uuid)}
                    underline="hover"
                    variant="body2"
                  >
                    {item.pricebook_code} {item.pricebook_name}
                  </Link>
                ) : (
                  <Typography variant="body2">{item.pricebook_code}</Typography>
                )}
                <PricebookItemPrice item={item} />
              </Stack>
            ))}
          </Stack>
        </>
      )}
    </>
  );
}
